import { render, staticRenderFns } from "./PrepareDocuments.vue?vue&type=template&id=61a5f0f8&scoped=true"
import script from "./PrepareDocuments.vue?vue&type=script&lang=js"
export * from "./PrepareDocuments.vue?vue&type=script&lang=js"
import style0 from "./PrepareDocuments.vue?vue&type=style&index=0&id=61a5f0f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a5f0f8",
  null
  
)

export default component.exports